module.exports = __webpack_public_path__ + "static/media/appointment-only.b7f316b9.svg";